<template>
  <div>
    <divcard>
      <div class="d-flex justify-space-between mb-3">
        <div v-if="userRole === 'USP'" class="d-flex" style="gap: 18px">
          <div class="theme-color-one font-type-bold left-side">{{ item.plan_master?.plan_code }}</div>
          <div class="black--text">
            <div>{{ item.plan_master?.plan_name_th }}</div>
            <div>{{ item.plan_master?.plan_name_en }}</div>
          </div>
        </div>

        <div v-else class="d-flex align-center" style="gap: 18px">
          <a class="black--text text-decoration-underline" :href="'/available-plan-list?id=' + item.id">
            {{ item.name }}
          </a>
        </div>

        <v-btn
            icon
            v-if="item.plan?.principle"
            :class="{ 'rotate180': isExpanded }"
            @click="seeDetail"
        >
          <Iconify
              icon="material-symbols:keyboard-arrow-down"
              color="#D3D3D3"
          ></Iconify>
        </v-btn>
      </div>

      <div class="d-flex align-center" style="gap: 18px">
        <Iconify
            class="left-side d-flex justify-end"
            size="15px"
            icon="jam:clock"
        ></Iconify>
        <div>{{ toDateRangeFormat(item.start_date, item.end_date) }}</div>
      </div>

      <div class="d-flex align-center" style="gap: 18px">
        <Iconify
            class="left-side d-flex justify-end"
            size="15px"
            icon="jam:clock"
            color="var(--theme-color-three)"
        ></Iconify>
        <div>หน่วยงานรับรองจนถึงวันที่ {{ toDateFormat(item.consider_date) }}</div>
      </div>

      <Button
          v-if="isNowInRange(item.start_date, item.end_date)"
          class="btn-pos"
          @onClick="offerPlan(item.plan)"
      >
        ยื่นโครงการ
      </Button>
      
    </divcard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="black--text font-type-bold mb-2">หลักการและเหตุผล</div>
        <div>
          {{ item.plan?.principle ?? '' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button"
import { mapState } from "vuex"
import { toDateFormat, toDateRangeFormat } from "../plugins/global-funcs"

export default {
  name: "AvailablePlanItem",
  components: {
    Button
  },
  props: {
    item: {
      default: () => ({})
    }
  },
  data () {
    return {
      toDateRangeFormat,
      toDateFormat,
      rand: 'cl-' + Math.random().toString().slice(2),
      isExpanded: false
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.Auth.User?.user_type,
    })
  },
  methods: {
    seeDetail () {
      let growDiv = document.querySelector('.' + this.rand + '.expand-layout')
      if (growDiv.clientHeight) {
        growDiv.style.height = 0
        this.isExpanded = false
      } else {
        let wrapper = document.querySelector('.' + this.rand + ' .expand-content')
        growDiv.style.height = (wrapper.clientHeight + 20) + "px"
        this.isExpanded = true
      }
    },
    offerPlan(plan) {
      const planId = plan[0]?.plan_master_id ?? null
      if (this.userRole === 'USP') {
        this.$router.push({ name: 'FormC', query: { round_id: this.item.id } })
      } else if (planId === 5) {
        this.$router.push({ name: 'FormD', query: { main_project_id: this.item.id } })
      } else if (planId === 6) {
        this.$router.push({ name: 'FormF', query: { main_project_id: this.item.id } })
      } else {
        this.$router.push({ name: 'FormA', query: { main_project_id: this.item.id } })
      }
    },
    isNowInRange(startDate, endDate) {
        const now = new Date();
        const start = new Date(startDate);
        const end = new Date(endDate);
        return now >= start && now <= end;
    }
  }

}
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height .2s;
  -ms-transition: height .2s;
  -o-transition: height .2s;
  -webkit-transition: height .2s;
  transition: height .2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #FAFAFA;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>